/**
 *  update by tannc 2018年12月24日20:33:50
 */

import { KNOWLEDGE_API ,KNOWLEDGE_SAVE_API,KNOWLEDGE_REMOVE_API} from '../resource/index';
import axios from '../config/axios.config';
export default {

   async save(params) {
      return await axios.save(KNOWLEDGE_SAVE_API,{},params);
   },
  async fetchData(id) {
    return await axios.get(KNOWLEDGE_API,{id:id});
  },
  async remove(id){
     return axios.remove(KNOWLEDGE_REMOVE_API,{id:id})
  }

}



// WEBPACK FOOTER //
// ./src/service/knowledgeService.js